module.exports = __webpack_public_path__ + "fonts/GmarketSansTTFMedium.d4bac6b.ttf";